<template>
    <div class="confirmContainer">
        <h2 class="mt-20 mb-15">Congratulations</h2>
        <p>
            Congratulations! You have committed investment of &#x20B9;{{selection.investmentAmount | localeAmount}} in the following loan. We will update your investment portfolio as soon as the funds are disbursed.
        </p>
        <div class="white-box p-15">
                <div class="d-flex justify-content-between">
                    <div>
                        <strong class="font-size-md"> Manual </strong>
                    </div>
                </div>
                <div class="portfolio-infoTable">
                    <div>
                        <p class="font-size-xs mb-0">Expected Earnings</p>
                        <strong class="text-primary">&#x20B9;{{selection.investmentAmount * selection.lenderInterestRate / 100 | localeAmount}}</strong>
                    </div>
                    <div>
                        <p class="font-size-xs mb-0">A.P.Y</p>
                        <strong class="text-primary">{{selection.lenderInterestRate}}%</strong>
                    </div>
                    <div>
                        <p class="font-size-xs mb-0">Invested</p>
                        <strong class="text-primary">&#x20B9;{{selection.investmentAmount | localeAmount}}</strong>
                    </div>
                </div>
            </div>

        <div class="dashboard__actions mt-30">
            <button class="btn btn-secondary px-5" @click="payPortfolio">
                Confirm
            </button>
        </div>
    </div>
</template>

<script>
import LenderService from '@/services/lenderService'

export default {
    name: 'PortfolioConfirm',
    props: {
        selection: Object
    },
    methods: {
        async payPortfolio () {
            this.$store.commit('isLoading')
            const cart = this.$store.getters['portfolio/getCartInvestment']
            if (cart.investmentType === 'manual' && this.$route.query.isManualInvest) {
                await LenderService.manualInvest(cart).then((res) => {
                    if (res.status === 200) {
                        this.$emit('success')
                    }
                })
            }
            this.$store.commit('isNotLoading')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";
.portfolio-infoTable {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.investment-card {
    position: relative;
    &__cta {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        a {
            text-decoration: none;
            font-size: $font-size-xxs;
            font-weight: 500;
        }
    }
    .white-box {
        border: 1px solid $form-border-color;
        margin-bottom: 24px;
    }

    .capitalize {
        text-transform: capitalize;
    }
}

.dashboard__actions {
    justify-content: flex-end;
}
</style>
